export default __webpack_public_path__ + "static/hatsfinance-8e0fdd8b77d6411ca908ffde2117f801.jpg";